import { processSteps } from '@/mocks/site';

export default function ProcessSteps() {
  return (
    <ol className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
      {processSteps.map((s) => (
        <li key={s.number} className="border-t border-foreground-950 pt-5">
          <span className="meta text-accent-600">{s.number}</span>
          <h3 className="mt-3 font-heading font-medium text-lg">{s.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600 max-w-xs">{s.text}</p>
        </li>
      ))}
    </ol>
  );
}